<template>
  <div v-if="!loading">
    <component :is="component" :tab-key="tabKey" />
  </div>
  <div v-else>
    <div class="d-flex justify-center align-center pa-6">
      <Loader />
    </div>
  </div>
</template>

<script>
import { computed, ref, onBeforeMount } from '@vue/composition-api';

import SeparatedContentTypeCalendar from './SeparatedContentTypeCalendar.vue';
import GenericContentTypeCalendar from './GenericContentTypeCalendar.vue';
import RepriseTable from '@/components/reprises/table/RepriseTable.vue';
import Loader from '@/components/common/Loader.vue';

import store from '@/store';

export default {
  components: {
    SeparatedContentTypeCalendar,
    GenericContentTypeCalendar,
    RepriseTable,
    Loader
  },
  props: {
    tabKey: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const loading = ref(false);
    const component = computed(() => {
      switch (props.tabKey) {
        case 'horse':
        case 'customer':
          return SeparatedContentTypeCalendar;
        case 'reprise':
          return RepriseTable;
        default:
          return GenericContentTypeCalendar;
      }
    });

    onBeforeMount(async () => {
      loading.value = true;
      switch (props.tabKey) {
        case 'horse':
          if (!store.state.isLazyLoaded.horses) {
            await store.dispatch('getHorses');
          }

          break;
        case 'instructor':
          if (!store.state.isLazyLoaded.instructors) {
            await store.dispatch('getInstructors');
          }
          break;
        case 'place':
          if (!store.state.isLazyLoaded.places) {
            await store.dispatch('getPlaces');
          }
          break;
        default:
          break;
      }
      loading.value = false;
    });

    return { component, loading };
  }
};
</script>
